export type FindPairingOptions<
  INPUT = unknown,
  RESULT = INPUT,
  REJECT = null,
> = {
  elements: INPUT[]
  produceResult: (
    a: INPUT,
    b: INPUT,
    indexOf: { a: number; b: number },
  ) => REJECT | RESULT
  reject?: REJECT
}

export const findPairing = <A = unknown, B = A>(
  options: FindPairingOptions<A, B>,
): B | null => {
  const { elements, produceResult, reject = null } = options
  for (let i = 0; i < elements.length - 1; i++) {
    const a = elements[i]
    for (let j = i + 1; j < elements.length; j++) {
      const b = elements[j]
      const result = produceResult(a, b, { a: i, b: j })
      if (result !== reject) {
        return result
      }
    }
  }

  return null
}
